import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const OfferList = React.lazy(() => import('@/modules/offer/components/list/offer-list'))
const OfferEditView = React.lazy(() => import('@/modules/offerV2/offer-edit-view'))
const OfferDetailComponent = React.lazy(() => import('@/modules/offer/components/detail/offer-detail.component'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const offerRoutes = (
  <>
    <Route path='offer/*' element={<RedirectToPlural />} />
    <Route path='offers' Component={OfferList} handle={{ title: 'Angebote', options: { noBackgroundColor: true } }} />

    <Route path='offers/new' Component={OfferEditView} />
    <Route path='offers/new/customer/:customerId' Component={OfferEditView} />
    <Route path='offers/edit/:id' Component={OfferEditView} />
    <Route path='offers/:id/:action?' Component={OfferDetailComponent} />
    <Route path='offers/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default offerRoutes
